<template>
  <footer class="w3l-footer-29-main">
    <div class="Bottom002743">
      <section class="auto auto_1600 clearfix">
        <div class="contact wow fadeInRight" style="visibility: visible; animation-name: fadeInRight;">
          <div class="name">深圳市乐福衡器有限公司</div>
          <ul class="ul">
            <li>
              <aside>{{ $t("contact_email") }}</aside>
              <b>pengsiyuan@lefu.cc</b>
            </li>
            <!--            <li>-->
            <!--              <aside>13149341131</aside>-->
            <!--            </li>-->
            <!--            <li>-->
            <!--              <aside>yilingfang@lefu.cc</aside>-->
            <!--            </li>-->
            <li>
              <aside>深圳市龙岗区坪地街道高桥社区环坪路22号盛隆兴产业园A栋6楼</aside>
            </li>
          </ul>
        </div>
        <nav class="clearfix wow fadeInRight" style="visibility: visible; animation-name: fadeInRight;">

          <dl style="margin-right: 112.844px;">
            <dt><a target="_blank" href="http://www.lefu.cc/weight/" >{{ $t("product_center") }}</a></dt>
            <dd><a target="_blank" href="http://www.lefu.cc/weight/">{{ $t("weight_scale") }}</a></dd>
            <dd><a target="_blank" href="http://www.lefu.cc/fattyfat/">{{ $t("body_fat_scale") }}</a></dd>
            <dd><a target="_blank" href="http://www.lefu.cc/nutrition/">{{ $t("kitchen_scale") }}</a></dd>
            <dd><a target="_blank" href="http://www.lefu.cc/2in1/">{{ $t("2in1_nutrition_scale") }}</a></dd>
          </dl>

          <dl style="margin-right: 112.844px;">
            <dt><a target="_blank" href="http://www.lefu.cc/process/">{{ $t("business_cooperation") }}</a></dt>
            <dd><a target="_blank" href="http://www.lefu.cc/process/">{{$t("cooperation_process")}}</a></dd>
            <dd><a target="_blank" href="http://www.lefu.cc/advantage/">{{$t("core_advantages")}}</a></dd>
            <dd><a target="_blank" href="http://www.lefu.cc/case/">{{$t("customer_cases")}}</a></dd>
          </dl>
          <dl style="margin-right: 112.844px;">
            <dt><a target="_blank" href="http://www.lefu.cc/introduction/">{{$t("about_us")}}</a></dt>
            <dd><a target="_blank" href="http://www.lefu.cc/introduction/">{{$t("lefufu_intro")}}</a></dd>
            <dd><a target="_blank" href="http://www.lefu.cc/culture/">{{$t("lefufu_culture")}}</a></dd>
            <dd><a target="_blank" href="http://www.lefu.cc/recruit/">{{$t("talent_recruitment")}}</a></dd>
          </dl>
        </nav>
        <div class="clear"></div>
      </section>
      <div class="copyright wow fadeInRight" style="visibility: visible; animation-name: fadeInRight;">
        Copyright © 深圳市乐福衡器有限公司 2021 All Rights Reserved <a href="https://beian.miit.gov.cn/" target="_blank"
                                                            rel="nofollow">粤ICP备15092680号</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
footer {
  width: 100%;
  height: 300px;
  color: #fff;
  background: rgb(25, 36, 58);
  overflow: hidden;
  text-align: center;
}

.w3l-footer-text-style h6 {
  font-size: 45px;
  font-weight: bold;
  color: var(--primary-color);
  text-decoration: underline;
  text-decoration-thickness: 2px;
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}

.Bottom002743 {
  /*background: #2f2d2a;*/
  padding: 1vw 0 2vw;
  color: rgba(255, 255, 255, 0.4);
}

.Bottom002743 .auto {
}

.Bottom002743 a {
  color: rgba(255, 255, 255, 0.4);
}

.Bottom002743 a:hover {
  color: #fff;
}

.Bottom002743 .copyright {
  /*margin-top: 4%;*/
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  line-height: 24px;
  padding: 35px 0 25px 0;
}

.Bottom002743 .copyright a {
}

.Bottom002743 .copyright a:hover {
}

.Bottom002743 .copyright a:not(:last-child):after {
  display: inline-block;
  content: '';
  width: 1px;
  height: 13px;
  background: rgba(255, 255, 255, 0.1);
  vertical-align: middle;
  margin: 0 12px;
}

.Bottom002743 .links {
  margin: 53px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  position: relative;
  line-height: 24px;
  padding: 11px 0 11px 70px;
}

.Bottom002743 .links a {
  display: inline-block;
}

.Bottom002743 .links span {
  position: absolute;
  left: 0;
  top: 11px;
  color: rgba(255, 255, 255, 0.4);
}

.Bottom002743 .links a:not(:last-child):after {
  display: inline-block;
  content: '';
  width: 1px;
  height: 13px;
  background: rgba(255, 255, 255, 0.07);
  vertical-align: middle;
  margin: 0 14px;
}

.Bottom002743 .contact {
  max-width: 560px;
}

.Bottom002743 .contact .name, .Bottom002743 nav dl dt {
  font-size: 18px;
  color: #fff;
  padding-bottom: 25px;
}

.Bottom002743 .contact li {
  padding-bottom: 10px;
}

.Bottom002743 .contact li aside {
  padding-left: 30px;
  background-position: left center;
  background-repeat: no-repeat;
}

.Bottom002743 .contact li:nth-child(1) {
  padding-bottom: 32px;
}

/*.Bottom002743 .contact li:nth-child(1) aside { background-image: url(../images/Bottom002743_icon_call.png); }*/
/*.Bottom002743 .contact li:nth-child(2) aside { background-image: url(../images/Bottom002743_icon_phone.png); }*/
/*.Bottom002743 .contact li:nth-child(3) aside { background-image: url(../images/Bottom002743_icon_email.png); }*/
/*.Bottom002743 .contact li:nth-child(4) aside { background-image: url(../images/Bottom002743_icon_add.png); }*/
.Bottom002743 .contact li b {
  font-size: 28px;
  padding-top: 5px;
  display: inline-block;
  color: #e77a1b;
}

.Bottom002743 nav dl dt a {
  color: #fff;
}

.Bottom002743 nav {
  float: right;
  width: 70%;
  max-width: 900px;
}

.Bottom002743 nav dl {
  float: left;
  max-width: 180px;
}

.Bottom002743 nav dd {
  line-height: 24px;
  padding: 4px 0;
}

.Bottom002743 nav .code {
  text-align: center;
}

.Bottom002743 nav .code img {
  max-width: 121px;
}

@media (min-width: 769px) {
  .Bottom002743 .contact {
    float: left;
  }

  .Bottom002743 .copyright aside {
    float: right;
  }
}

@media (max-width: 768px) {
  .Bottom002743 {
    padding-top: 5%;
  }

  .Bottom002743 nav {
    width: 100%;
    float: none;
    text-align: center;
  }

  .Bottom002743 nav dl:not(:last-child) {
    display: none;
  }

  .Bottom002743 nav dl {
    float: none;
    display: inline-block;
    margin-top: 15px;
  }

  .Bottom002743 .contact {
    display: table;
    margin: 0 auto;
  }

  .Bottom002743 .contact li:nth-child(1) {
    padding-bottom: 10px;
  }

  .Bottom002743 .links {
    margin: 30px 0;
  }

  .Bottom002743 .contact .name, .Bottom002743 .copyright {
    text-align: center;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/Footer.vue